export const COLLECTION_PATH = Object.freeze({
    TASKS: {
        COLLECTION: 'bar/tasks/taskCollection',
        ROOT: 'bar/tasks'
    }
})